import { http } from "../../../common/http";

class NewsTypeService {
	list = () => {
		return http({
			method: "GET",
			url: "/news-type",
		});
	};
	
	detail = (id: number) => {
		return http({
			method: "GET",
			url: `/news-type/${id}`,
		});
	};
}
export default new NewsTypeService();
